import { useCallback, useEffect, useState } from 'react';
import { Flex, TextField, View } from '@adobe/react-spectrum';
import { useDebounce } from '@uidotdev/usehooks';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../state/store';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import styles from './filter_product_code_component.module.css';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import { useTranslation } from 'react-i18next';
interface IFilterProductCodeProps {
  onSearchChange?: (params: {}) => void;
  filterParams?: any;
  serachedText?: string;
  createParams: (filterType: any, filterValue: any) => void;
  clearFilters?: boolean
}

const FilterProductCode: React.FC<IFilterProductCodeProps> = ({ onSearchChange, filterParams, serachedText, createParams }) => {
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);
  const [filterTerm, setFilterTerm] = useState<string>(serachedText ?? '');
  const debouncedFilterTerm = useDebounce(filterTerm, 1000);
  const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
  const { isMobile } = useViewInfo();
  const { t } = useTranslation('products');
  const _t = (key: string) => t(`product_filters.${key}`, { ns: 'products' });

  useEffect(() => {
    (async () => {
      searchProducts();
    })();
  }, [debouncedFilterTerm]);

  useEffect(() => {
    setFilterTerm('');
  }, [selectedApp]);

  const handleFiltering = async (e: any) => {
    setFilterTerm(e);
  };

  const searchProducts = useCallback(async () => {

    if (!filterParams?.FILTER?.COL?.some((obj: any) => obj.name === 'product_code') && debouncedFilterTerm === '') {
      return;
    }

    createParams('product_code', debouncedFilterTerm);
  }, [debouncedFilterTerm]);

  return (
    <Flex direction={'column'} minWidth={'200px'} marginTop={'5px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'}>
      <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.product_code_container}>
        <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.product_code_heading}>
          <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
            <View position={'relative'} UNSAFE_className={styles.product_code_heading_text}>
              {_t('search_by_product_code')}
            </View>
          </Flex>

          {toggleListVisibility.stateList ? (
            <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
          ) : (
            <ChevronUp color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
          )}
        </Flex>
        <Flex
          direction={'column'}
          width={'200px'}
          alignItems={'start'}
          justifyContent={'start'}
          UNSAFE_className={styles.product_code_search_input}
          marginStart={'10px'}
          marginEnd={'10px'}
          UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}>
          <Flex direction={'row'}
            height={'32px'}
            alignSelf={'stretch'}
            flexShrink={0} alignItems={'center'} justifyContent={'end'} UNSAFE_className={styles.product_code_search}>
            <TextField value={filterTerm} width={'100%'} onChange={handleFiltering} aria-label={_t('search_by_product_code')} />
            <i className={`${styles.icon_product_code_search} bi bi-search`}></i>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
};

export default FilterProductCode;
